<template>
  <tk-container
    class=""
  >
    <div
      slot="header"
      class="mb-10 px-15 pt-15"
    >
      <global-back />
    </div>
    <div class="p-15">
      <div
        class="h-full text-15 pt-0"
      >
        <div
          class="flex cursor-pointer items-center justify-between border-gray-F1F4F8 pt-2 pb-22 border-b border-width-1"
        >
          <div>头像</div>
          <van-uploader
            :after-read="upload"
          >
            <div
              class="circle-48 flex-center overflow-hidden"
            >
              <van-loading
                v-if="uploading"
                size="24px"
              />
              <img
                v-else
                class="circle-48 overflow-hidden"
                :src="avatar"
              >
            </div>
          </van-uploader>
        </div>
        <van-cell-group
          :border="false"
          style="background: transparent !important;"
          class="border-gray-F1F4F8 py-16 !-mx-0 bg-transparent border-b border-width-1"
        >
          <van-field
            v-model="nickName"
            label="昵称"
            maxlength="11"
            input-align="right"
            placeholder="请输入昵称"
            error-message-align="right"
            :error-message="!nickName ? '昵称不可为空' : ''"
            class="border-width-1 p-0"
          />
        </van-cell-group>
        <van-cell-group
          :border="false"
          style="background: transparent !important;"
          class="border-gray-F1F4F8 py-16 !-mx-0 border-b border-width-1"
        >
          <van-field
            v-model="phone"
            label="手机号"
            input-align="right"
            placeholder="请输入手机号"
            error-message-align="right"
            :error-message="errorPhoneText"
            class="p-0"
          />
        </van-cell-group>
        <!-- 按钮 -->
        <div
          class="mt-135 w-full overflow-hidden rounded-16"
        >
          <van-button
            class="w-full"
            color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
            :disabled="disabled"
            :loading="btnLoading"
            @click="submit"
          >
            保存
          </van-button>
        </div>
      </div>
      </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
export default {
  name: 'account-info',
  data () {
    return {
      uploading: false,
      btnLoading: false,
      phone: this.$store.state.user.phone,
      avatar: this.$store.state.user.avatar || '/img/avatar.png',
      nickName: this.$store.state.user.nickName || this.$store.state.user.phone,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    errorPhoneText () {
      return this.phone && !/^1[2-9]\d{9}$/.test(this.phone) ? '手机号格式错误' : ''
    },
    disabled () {
      return !this.nickName || !!this.errorPhoneText || !this.phone || this.uploading
    },
  },
  methods: {
    async upload (info) {
      this.uploading = true
      const reader = new FileReader()
      reader.onload = async () => {
        try {
          const { data: res } = await this.$tkParse.post('/files', reader.result)
          this.avatar = res.url
          this.uploading = false
        } catch (e) {
          this.uploading = false
          Toast({
            message: '网络错误，请重试',
            position: 'bottom',
          })
        }
      }
      reader.readAsArrayBuffer(info.file)
    },
    async submit () {
      this.btnLoading = true
      // eslint-disable-next-line no-useless-escape
      let reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      await this.$tkParse.put(`/classes/_User/${this.user.objectId}`, {
        role: null,
        department: null,
        nickName: this.nickName,
        avatar: reg.test(this.avatar) ? this.avatar : null,
        phone: this.phone,
      }).catch((e) => {
        Toast.fail('保存失败')
        this.btnLoading = false
        throw e
      })
      this.$store.state.user.nickName = this.nickName
      this.$store.state.user.phone = this.phone
      this.$store.state.user.avatar = reg.test(this.avatar) ? this.avatar : null
      // 保存成功提示
      Toast.success('保存成功')
      this.btnLoading = false
      this.$back()
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-cell {
    background: transparent !important;
  }
  .disabled {
    .van-cell__title {
      color: #9c9c9c;
    }
    .van-field__control {
      color: #9C9C9C;
    }
  }
}
</style>
